<rt-interview-base-box
  [question]="questionForm.getRawValue()"
  [invalid]="isInvalid(questionForm) && formSubmissionAttempt"
  [formGroup]="questionForm"
>
  @if (isQuestionType(questionForm, QuestionKind.SingleChoice)) {
    <rt-radio-form-group
      [items]="$any(options)"
      [rtProtectedControl]="questionForm.controls.content"
      formControlName="content"
    >
    </rt-radio-form-group>
  }

  @if (isQuestionType(questionForm, QuestionKind.MultipleChoice)) {
    <rt-group variant="vertical" formArrayName="contents">
      @for (
        option of questionForm.controls.options.controls;
        track trackByOption(i, option);
        let i = $index
      ) {
        <rt-checkbox
          [value]="option.value.title"
          [rtProtectedControl]="questionForm.controls.contents"
          [formControlName]="i"
        >
          {{ option.value.title }}
        </rt-checkbox>
      }
    </rt-group>
  }

  @if (isQuestionType(questionForm, QuestionKind.Boolean)) {
    <rt-radio-form-group
      [items]="$any(options)"
      [rtProtectedControl]="questionForm.controls.content"
      formControlName="content"
    >
    </rt-radio-form-group>
  }

  @if (isQuestionType(questionForm, QuestionKind.Dropdown)) {
    <rt-select
      [options]="$any(options)"
      [hasSearch]="false"
      [includeEmptyOption]="!questionForm.value.questionRequired"
      [rtProtectedControl]="questionForm.controls.content"
      formControlName="content"
    >
    </rt-select>
  }
</rt-interview-base-box>
